var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4188_25788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8789 9.875H11.9375H10.9258H10.625V10.1211V11.1875V12.3086V14.7422L8 12.8008C8.02734 12.3086 8.30078 11.8438 8.68359 11.543L9.3125 11.1055V9.875C9.3125 9.16406 9.88672 8.5625 10.625 8.5625H12.7031L14.0703 7.57812C14.3438 7.35938 14.6445 7.25 15 7.25C15.3281 7.25 15.6289 7.35938 15.9023 7.55078L17.2695 8.5625H19.375C20.0859 8.5625 20.6875 9.16406 20.6875 9.875V11.1055L21.2891 11.543C21.6719 11.8438 21.9453 12.3086 21.9727 12.8008L19.375 14.7422V12.3086V11.1875V10.1211V9.875H19.0469H18.0625H16.0938H13.8789ZM8 19.5V13.8945L13.9336 18.2969C14.2344 18.5156 14.6172 18.625 15 18.625C15.3555 18.625 15.7383 18.5156 16.0391 18.2969L22 13.8945V19.5C22 20.4844 21.207 21.25 20.25 21.25H9.75C8.76562 21.25 8 20.4844 8 19.5ZM15.5469 10.9688V11.3516C15.7383 11.4062 15.9297 11.4336 16.1211 11.4883C16.3945 11.5703 16.5859 11.8711 16.5039 12.1719C16.4219 12.4453 16.1211 12.6367 15.8203 12.5547C15.5195 12.4727 15.2461 12.418 14.9727 12.418C14.7539 12.3906 14.5352 12.4453 14.3984 12.5547C14.2617 12.6094 14.207 12.6914 14.207 12.8008C14.207 12.8555 14.2344 12.8828 14.3711 12.9922C14.5352 13.0742 14.7812 13.1562 15.1367 13.2656H15.1641C15.4648 13.375 15.8477 13.4844 16.1758 13.6758C16.5312 13.8945 16.832 14.2773 16.832 14.8242C16.8594 15.3984 16.5586 15.8086 16.1758 16.0547C15.957 16.1641 15.7383 16.2461 15.5195 16.3008V16.6562C15.5195 16.957 15.2734 17.2031 14.9727 17.2031C14.6719 17.2031 14.4258 16.957 14.4258 16.6562V16.2734C14.1523 16.2188 13.8789 16.1094 13.6602 16.0273C13.6055 16.0273 13.5508 16 13.4961 15.9727C13.2227 15.8906 13.0586 15.5898 13.168 15.2891C13.25 15.0156 13.5508 14.8516 13.8516 14.9336C13.9062 14.9609 13.9883 14.9883 14.043 15.0156C14.4258 15.125 14.6992 15.2344 15 15.2344C15.2461 15.2617 15.4648 15.207 15.6016 15.125C15.7109 15.043 15.7656 14.9609 15.7383 14.8242C15.7383 14.7422 15.7383 14.6875 15.6016 14.6055C15.4102 14.4961 15.1641 14.4141 14.8359 14.3047H14.7812C14.4805 14.1953 14.0977 14.0859 13.7969 13.9219C13.4688 13.7031 13.1406 13.3477 13.1406 12.8008C13.1133 12.2266 13.4414 11.8164 13.8242 11.5977C14.0156 11.4883 14.2344 11.4062 14.4531 11.3789V10.9688C14.4531 10.668 14.6992 10.4219 15 10.4219C15.3008 10.4219 15.5469 10.668 15.5469 10.9688Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4188_25788",
    x: 0,
    y: -0.75,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.733333 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4188_25788"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4188_25788",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashout);
export default ForwardRef;